import { baseApi, TAGS } from 'shared/api';

import { NotificationsResponseModel } from '../model/types';

export type GetNotificationsRequestParams = {
  dateRange: number | null;
  pageNumber: number | null;
  pageSize: number | null;
  searchTerm: string;
  showOnlyUnreadNotificationsField: boolean;
  sortParams: { id: string; order: 'asc' | 'desc' };
};

function isNumber(value: unknown): value is number {
  return typeof value === 'number' && !isNaN(value);
}

function createParam(type: 'filter' | 'request', paramName: string) {
  return `${type}Settings.${paramName}`;
}

function buildIdsSearchParams(ids: string[]) {
  const searchParams = new URLSearchParams();

  for (const id of ids) {
    searchParams.append('ids', id);
  }

  return searchParams.toString();
}

export const newsLettersApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getNewsletters: build.query<
      NotificationsResponseModel,
      GetNotificationsRequestParams
    >({
      query: ({
        dateRange,
        pageNumber,
        pageSize,
        searchTerm,
        showOnlyUnreadNotificationsField,
        sortParams,
      }) => ({
        url: `/user/notifications`,
        method: 'GET',
        params: {
          [createParam('filter', 'onlyNotRead')]:
            showOnlyUnreadNotificationsField,
          ...(searchTerm && {
            [createParam('filter', 'search')]: searchTerm,
          }),
          ...(isNumber(pageNumber) && {
            [createParam('request', 'pageNumber')]: pageNumber,
          }),
          ...(isNumber(pageSize) && {
            [createParam('request', 'pageCount')]: pageSize,
          }),
          ...(isNumber(dateRange) && {
            [createParam('filter', 'lastDays')]: dateRange,
          }),
          [createParam(
            'request',
            'sort'
          )]: `${sortParams.id}:${sortParams.order}`,
        },
      }),
      providesTags: [TAGS.NEWSLETTERS],
    }),
    markNewslettersAsRead: build.mutation<{ Data: string[] }, string[]>({
      query: (ids) => ({
        url: `/user/notifications/markasread?${buildIdsSearchParams(ids)}`,
        method: 'PUT',
      }),
      invalidatesTags: (res) => (res?.Data.length ? [TAGS.NEWSLETTERS] : []),
    }),
  }),
});
